// Module
var code = "<template> <require from=\"app/cm/components/household/household-case-diagnoses-grid\" as=\"diagnoses-view\"></require> <diagnoses-view household-case-id.bind=\"householdCaseId\"></diagnoses-view> </template> ";
// Exports
module.exports = code;